import { createSafeContext } from '@/lib/context';
import type { Maybe } from '@/lib/types';

export type CommonModalProviderContext = {
  closeNotifyMe: () => void;
  openCampaignNewsletterModal: (props: any) => void;
  openNotifyMe: (props: any) => void;
  setContactUsModalStatus: (show: boolean, sku?: Maybe<string>) => void;
  setGetMyNFTModalStatus: (show: boolean) => void;
  setPriceModalStatus: (show: boolean) => void;
  setWarrantyExtensionModalStatus: (show: boolean) => void;
};

export const { Provider, useContext: useCommonModalProviderContext } =
  createSafeContext<CommonModalProviderContext>(
    'useCommonModalProviderContext must be used inside a CommonModalProviderContext',
  );
